import { render, staticRenderFns } from "./BuddhaBirthday.vue?vue&type=template&id=c8b826fa&scoped=true"
import script from "./BuddhaBirthday.vue?vue&type=script&lang=js"
export * from "./BuddhaBirthday.vue?vue&type=script&lang=js"
import style0 from "./BuddhaBirthday.vue?vue&type=style&index=0&id=c8b826fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b826fa",
  null
  
)

export default component.exports